import { ListBulletIcon } from '@heroicons/react/24/outline'
import { useChat } from '../../providers/chat/context'

export default function PlanToggle({ disabled = false }: { disabled?: boolean }) {
  const { planMode, setPlanMode } = useChat()

  return (
    <button
      type="button"
      aria-pressed={planMode}
      disabled={disabled}
      onClick={() => setPlanMode(!planMode)}
      data-tooltip={planMode ? 'Plan mode on: you approve a plan before anything runs' : 'Plan first, then run'}
      data-tooltip-above
      data-tooltip-start
      className={`flex h-8 items-center gap-1 rounded-full px-2.5 text-xs font-medium transition disabled:opacity-30 sm:h-6 sm:px-2 sm:text-[11px] ${
        planMode
          ? 'bg-purple-50 text-purple-800 ring-1 ring-purple-200 hover:bg-purple-100'
          : 'text-stone-500 hover:bg-stone-100 hover:text-stone-700'
      }`}
    >
      <ListBulletIcon className="size-4 sm:size-3.5" />
      Plan
    </button>
  )
}
